module.exports = __webpack_public_path__ + "static/img/star.d1b13e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/particles/images/star.png
// module id = Zp86
// module chunks = 0